import React, { useState, useRef } from "react";
import "./eventDetails.css";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import emailjs from "@emailjs/browser";
import SummaryBox from "../../components/SummaryBox/SummaryBox";
export default function EventDetails() {
  const [quote, setQuote] = useState({
    guests: 50,
    eventType: "",
    evChargePoints: false,
    soundSystem: false,
    marquee: false,
    bar: false,
    onsiteCatering: false,
    stageAndDancefloor: false,
    toilets: false,
    outdoorLighting: false,
    w3wCode: "",
    postcode: "",
    deliveryDate: new Date(),
    collectionDate: new Date(),
  });

  const [services, setServices] = useState([]);
  const [displayErr, setDisplayErr] = useState(false);
  let navigate = useNavigate();
  const form = useRef();

  function sendEmail(e) {
    e.preventDefault();
    if (
      !quote.eventType ||
      !quote.deliveryDate ||
      !quote.collectionDate ||
      form.current.firstName.value.length < 1 ||
      form.current.lastName.value.length < 1 ||
      form.current.email.value.length < 1
    ) {
      displayErrMsg();
      return;
    }
    emailjs
      .sendForm(
        "service_mfsip79",
        "template_fefdifw",
        form.current,
        "user_2llXx0wmUZW2esUxwtHRS"
      )
      .then(
        (result) => {
          console.log(result.text);
          navigate("/confirmation");
        },
        (error) => {
          console.log(error.text);
        }
      );
  }

  function displayErrMsg() {
    setDisplayErr(true);
    window.setTimeout(() => {
      setDisplayErr(false);
    }, 5000);
  }

  function correctlyFormatService(ser) {
    switch (ser) {
      case "evChargePoints":
        return "Electric Vehicle Charge Points";
      case "soundSystem":
        return "Soundsystem Power";
      case "marquee":
        return "Marquee";
      case "bar":
        return "Bar";
      case "onsiteCatering":
        return "Onsite Catering";
      case "stageAndDancefloor":
        return "Stage and Dancefloor";
      case "toilets":
        return "Toilets";
      case "outdoorLighting":
        return "Outdoor Lighting";
      default:
    }
  }

  function navToFestival() {
    navigate("/festival");
  }

  function handleGuestsChange(e) {
    setQuote({ ...quote, guests: e.target.value });
  }

  function setEventType(eventType) {
    setQuote({ ...quote, eventType: eventType });
  }

  function flipBoolVal(ser) {
    setQuote({ ...quote, [ser]: !quote[ser] });
    if (services.indexOf(ser) === -1) {
      setServices([...services, ser]);
    } else {
      setServices(services.filter((service) => service !== ser));
    }
  }

  function formatDateString(d) {
    return d.toString().split(" ").slice(1, 4);
  }

  return (
    <div className="event-details">
      <div>
        <h2 className="sub-header">Bright Form </h2>

        <p>
          Please click the boxes which bests describes your event and needs.
        </p>
        <p> This helps us recommend the best equipment to you.</p>
      </div>
      <div className="page-portion">
        <div className="portion-item">
          <h2 className="sub-header cat-title">Event</h2>
          <h2 className="sub-header cat-title">Type</h2>
        </div>
        <div
          className={
            quote.eventType === "Wedding/Private Party"
              ? "portion-item selected-item"
              : "portion-item"
          }
          onClick={() => setEventType("Wedding/Private Party")}
        >
          <div className="question-header">
            <div className="title-tick">
              <h2 className="sub-header">Wedding or Private party</h2>
              <img
                alt=""
                className="tick-img"
                src={
                  quote.eventType === "Wedding/Private Party"
                    ? "./imgs/tick.png"
                    : "./imgs/untick.png"
                }
              />
            </div>
          </div>
        </div>
        <div
          className={
            quote.eventType === "Corporate Event"
              ? "portion-item selected-item"
              : "portion-item"
          }
          onClick={() => setEventType("Corporate Event")}
        >
          <div onClick={() => setEventType("Corporate Event")}>
            <div className="question-header">
              <div className="title-tick">
                <h2 className="sub-header">Corporate Event</h2>
                <img
                  alt=""
                  className="tick-img"
                  src={
                    quote.eventType === "Corporate Event"
                      ? "./imgs/tick.png"
                      : "./imgs/untick.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="portion-item" onClick={() => navToFestival()}>
          <div className="question-header" onClick={() => navToFestival()}>
            <div className="title-tick">
              <h2 className="sub-header">Festival</h2>
              <img
                alt=""
                className="tick-img"
                src={
                  quote.eventType === "Festival"
                    ? "./imgs/tick.png"
                    : "./imgs/untick.png"
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="guests-wrapper">
        <h1 className="guests-counter">
          {quote.guests}
          {quote.guests > 490 ? "+" : ""} Guests
        </h1>
        <input
          type="range"
          id="guests"
          name="guests"
          min="10"
          max="500"
          step="10"
          className="slider"
          onChange={(e) => handleGuestsChange(e)}
          defaultValue="50"
        ></input>
      </div>
      <div className="page-portion ">
        <div className="portion-item">
          <h2 className="sub-header cat-title">What kit</h2>
          <h2 className="sub-header cat-title">do you</h2>
          <h2 className="sub-header cat-title">need?</h2>
        </div>
        <div className="portion-item main-section">
          <div className="event-grid">
            <div
              className={
                quote.evChargePoints ? "grid-item-selected" : "grid-item"
              }
              onClick={() => flipBoolVal("evChargePoints")}
            >
              EV Charging Points
              <img
                alt=""
                className="tick-img"
                src={
                  quote.evChargePoints ? "./imgs/tick.png" : "./imgs/untick.png"
                }
              />
            </div>
            <div
              className={quote.soundSystem ? "grid-item-selected" : "grid-item"}
              onClick={() => flipBoolVal("soundSystem")}
            >
              Soundsystem Power
              <img
                alt=""
                className="tick-img"
                src={
                  quote.soundSystem ? "./imgs/tick.png" : "./imgs/untick.png"
                }
              />
            </div>
            <div
              className={quote.marquee ? "grid-item-selected" : "grid-item"}
              onClick={() => flipBoolVal("marquee")}
            >
              Marquee Heating
              <img
                alt=""
                className="tick-img"
                src={quote.marquee ? "./imgs/tick.png" : "./imgs/untick.png"}
              />
            </div>
            <div
              className={quote.bar ? "grid-item-selected" : "grid-item"}
              onClick={() => flipBoolVal("bar")}
            >
              bar
              <img
                alt=""
                className="tick-img"
                src={quote.bar ? "./imgs/tick.png" : "./imgs/untick.png"}
              />
            </div>
            <div
              className={
                quote.onsiteCatering ? "grid-item-selected" : "grid-item"
              }
              onClick={() => flipBoolVal("onsiteCatering")}
            >
              onsite catering
              <img
                alt=""
                className="tick-img"
                src={
                  quote.onsiteCatering ? "./imgs/tick.png" : "./imgs/untick.png"
                }
              />
            </div>
            <div
              className={
                quote.stageAndDancefloor ? "grid-item-selected" : "grid-item"
              }
              onClick={() => flipBoolVal("stageAndDancefloor")}
            >
              stage and dancefloor
              <img
                alt=""
                className="tick-img"
                src={
                  quote.stageAndDancefloor
                    ? "./imgs/tick.png"
                    : "./imgs/untick.png"
                }
              />
            </div>
            <div
              className={quote.toilets ? "grid-item-selected" : "grid-item"}
              onClick={() => flipBoolVal("toilets")}
            >
              toilets
              <img
                alt=""
                className="tick-img"
                src={quote.toilets ? "./imgs/tick.png" : "./imgs/untick.png"}
              />
            </div>
            <div
              className={
                quote.outdoorLighting ? "grid-item-selected" : "grid-item"
              }
              onClick={() => flipBoolVal("outdoorLighting")}
            >
              outdoor lighting
              <img
                alt=""
                className="tick-img"
                src={
                  quote.outdoorLighting
                    ? "./imgs/tick.png"
                    : "./imgs/untick.png"
                }
              />
            </div>
          </div>
        </div>
      </div>
      <img alt="" className="panel-img flow-img" src={"./imgs/generator.png"} />
      <div className="page-portion">
        <div className="portion-item">
          <h2 className="sub-header cat-title">Where & </h2>
          <h2 className="sub-header cat-title"> when</h2>
        </div>
        <div className="portion-item portion-vertical-flex">
          <div className="where-when">
            <p>WHERE?</p>
            <p>Use What3Words or postcode </p>
            <p>to locate your site.</p>
          </div>
          <div className="datepicker">
            <h2 className="sub-header">Post Code</h2>

            <input
              type="text"
              optional
              placeholder="Postcode"
              onChange={(e) => setQuote({ ...quote, postcode: e.target.value })}
              className="where-when-input"
            />
            <br />
            <h2 className="sub-header">OR</h2>
            <h2 className="sub-header">What3Words Code</h2>

            <input
              type="text"
              optional
              placeholder="W3W Code"
              onChange={(e) => setQuote({ ...quote, w3wCode: e.target.value })}
              className="where-when-input"
            />
          </div>
        </div>
        <div className="portion-item portion-vertical-flex">
          <div className="where-when">
            <p>WHEN?</p>
            <p>We always arrive the day before </p>
            <p>to set up and install</p>
          </div>
          <div className="datepicker">
            <h2 className="sub-header">Delivery Date</h2>
            <DatePicker
              selected={quote.deliveryDate}
              onChange={(date) => setQuote({ ...quote, deliveryDate: date })}
              dateFormat="dd/MM/yyyy"
              className="where-when-input-date"
            />
            <h2 className="sub-header">AND</h2>

            <h2 className="sub-header">Collection Date</h2>
            <DatePicker
              selected={quote.collectionDate}
              onChange={(date) => setQuote({ ...quote, collectionDate: date })}
              dateFormat="dd/MM/yyyy"
              className="where-when-input-date"
            />
          </div>
        </div>
      </div>
      <img
        alt=""
        className="panel-img flow-img almost"
        src={"./imgs/almostfinished.png"}
      />
      <div className="in-summary">
        <div className="summary-portion-item">
          <h2 className="sub-header cat-title">in </h2>
          <h2 className="sub-header cat-title">summary</h2>
        </div>
        <div className="summary-portion-item">
          <div className="nested-item nested-top">
            {quote.eventType ? quote.eventType : "Event Type is Required"}
          </div>
          <div className="nested-item nested-top">{quote.guests} Guests</div>
        </div>
        <div className="summary-portion-item">
          <div className="nested-item">
            <p>ev charging points</p>
            {quote.evChargePoints && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>band / dj</p>
            {quote.soundSystem && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>marquee heating</p>
            {quote.marquee && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>bar</p>
            {quote.bar && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
        </div>
        <div className="summary-portion-item">
          <div className="nested-item">
            <p>onsite catering</p>
            {quote.onsiteCatering && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>stage and dancefloor</p>
            {quote.stageAndDancefloor && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>toilets</p>
            {quote.toilets && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
          <div className="nested-item">
            <p>outdoor lighting</p>
            {quote.outdoorLighting && (
              <img alt="" className="tick-img" src="./imgs/tick.png" />
            )}
          </div>
        </div>
        <div className="summary-portion-item">
          <div className="nested-item">
            <p>location & dates</p>
          </div>
          <div className="nested-item">
            {quote.postcode && <p>Postcode: {quote.postcode}</p>}
            {quote.w3wCode && <p>W3W Code: {quote.w3wCode}</p>}
          </div>
          <div className="nested-item">
            <SummaryBox
              title="delivery"
              dates={formatDateString(quote.deliveryDate)}
            />
          </div>
          <div className="nested-item">
            <SummaryBox
              title="collection"
              dates={formatDateString(quote.collectionDate)}
            />
          </div>
        </div>
      </div>
      <img alt="" className="panel-img flow-img" src={"./imgs/festival.png"} />
      <div className="in-summary">
        <div className="summary-portion-item">
          <h2 className="sub-header cat-title">your </h2>
          <h2 className="sub-header cat-title"> details</h2>
        </div>
        <form
          ref={form}
          className="summary-portion-item contact-form double-box"
          onSubmit={sendEmail}
        >
          {services.map((service) => (
            <input
              className="hidden-input"
              type="text"
              value={correctlyFormatService(service)}
              name={service}
            />
          ))}
          <input
            className="hidden-input"
            type="text"
            value={formatDateString(quote.deliveryDate)}
            name="delDate"
          />
          <input
            className="hidden-input"
            type="text"
            value={formatDateString(quote.collectionDate)}
            name="colDate"
          />
          <input
            className="hidden-input"
            type="text"
            value={quote.guests}
            name="guests"
          />
          <input
            className="hidden-input"
            type="text"
            value={quote.eventType}
            name="eventType"
          />
          <input
            className="hidden-input"
            type="text"
            value={quote.w3wCode}
            name="w3w"
          />
          <input className="hidden-input" type="text" value={quote.postcode} />
          <input
            className="contact-form-input sml-input"
            type="text"
            placeholder="First Name"
            name="firstName"
            required
          />
          <input
            className="contact-form-input sml-input"
            type="text"
            placeholder="Last Name"
            name="lastName"
            required
          />
          <input
            className="contact-form-input"
            type="text"
            placeholder="Phone Number"
            name="phoneNumber"
            required
          />
          <input
            className="contact-form-input"
            type="email"
            placeholder="Email"
            name="email"
            required
          />
          <textarea
            className="contact-form-input"
            type="text"
            placeholder="Comments"
            name="message"
          />
        </form>
        <div className="summary-portion-item" onClick={sendEmail}>
          <div className="complete">
            <img alt="" className="complete-img" src="./imgs/tick.png" />
            <h2 className="sub-header">click to complete</h2>
            {displayErr && (
              <p>
                Looks like you missed some options! Check again before
                submitting
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
